// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Z_x3","content":"LoadingAlert_content__26sxa"};